export default "__VITE_ASSET__fcn1zEYvoumSGXGdCf_71g__"